var swiper = require('./module/swiper.js');
var nav = require('./module/nav.js');
var instagram = require('./module/instagram.js');
var map_change = require('./module/map_change.js');
